/**
 * Google Analytics 4 — env-gated, same inert-until-configured pattern as metaPixel.js.
 * No-ops until REACT_APP_GA4_MEASUREMENT_ID is set.
 */

let initialized = false;

function loadGa4Script(measurementId) {
  if (typeof window === "undefined") return;
  if (window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", measurementId);

  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export function initGa4() {
  if (initialized) return;
  const measurementId = String(process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
  if (!measurementId) {
    if (process.env.NODE_ENV === "development") {
      console.debug("[ga4] REACT_APP_GA4_MEASUREMENT_ID not set — GA4 disabled");
    }
    return;
  }
  try {
    loadGa4Script(measurementId);
    initialized = true;
  } catch (err) {
    console.warn("[ga4] failed to initialize:", err?.message || err);
  }
}

export function trackGa4Event(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch {
    /* tracking must never break the signup flow */
  }
}
